import { render, staticRenderFns } from "./MyProcessList.vue?vue&type=template&id=3c6f9a10&scoped=true"
import script from "./MyProcessList.vue?vue&type=script&lang=js"
export * from "./MyProcessList.vue?vue&type=script&lang=js"
import style0 from "./MyProcessList.vue?vue&type=style&index=0&id=3c6f9a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6f9a10",
  null
  
)

export default component.exports